import * as React from "react";
import Logo from "../assets/imgs/bodewrk-logo.png";
import MessagesIcon from "../assets/imgs/messages-icon.svg";
import NotificationsIcon from "../assets/imgs/notifications-icon.svg";
import { makeStyles } from "@mui/styles";
import "../styles/Nav.scss";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles({
  navigation: {
    background: "#FFFFFF",
  },
  navLinks: {
    display: "flex",
    padding: 0,
    marging: 0,
    listStyle: "none",
    margin: 0,
  },
  link: {
    opacity: 1,
    margin: "0 10px",
    textAlign: "center",
    textDecoration: "none",
    color: "",
    fontSize: "18px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  activeLink: {
    borderBottom: "2px solid #111111",
    fontWeight: "bold",
  },
  navWrapper: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
});

const Navigation = () => {
  const classes = useStyles();

  return (
    <div className="container">
      <div className="nav-wrapper">
        <div className="d-flex align-items-center loginNavWrapper justify-content-md-center justify-content-lg-between justify-content-sm-center justify-content-xs-center">
          <div className="d-flex align-items-center justify-content-sm-center">
            <img src={Logo} alt="Bod-E-Woek Logo" width={99} height={58} />
            <h3 className="logo-text d-inline-block m-0 text-black font-weight-bold">
              BodeWrk
            </h3>
          </div>
          <div className={`${classes.navLinks}`} id="login-nav-links">
            <div>
              <NavLink
                className={({ isActive }) =>
                  isActive ? classes.activeLink + " link" : "link"
                }
                to="/business"
              >
                <p className="nav-link m-0">Business</p>
              </NavLink>
            </div>
            <div>
              <NavLink
                className={({ isActive }) =>
                  isActive ? classes.activeLink + " link" : "link"
                }
                to="/get-the-app"
              >
                <p className="nav-link m-0">Get the App</p>
              </NavLink>
            </div>
            <div>
              <NavLink
                className={({ isActive }) =>
                  isActive ? classes.activeLink + " link" : "link"
                }
                to="/contact-us"
              >
                <p className="nav-link m-0">Contact Us</p>
              </NavLink>
            </div>
            <div>
              <NavLink
                className={({ isActive }) =>
                  isActive ? classes.activeLink + " link" : "link"
                }
                to="/login"
              >
                <p className="nav-link m-0">Login</p>
              </NavLink>
            </div>
            <div>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? classes.activeLink + " link sign-up-btn-wrapper"
                    : "link sign-up-btn-wrapper"
                }
                // className={`${classes.link} sign-up-btn-wrapper`}
                to="/sign-up"
              >
                <button id="nav-sign-up-btn">Sign Up</button>
              </NavLink>
            </div>
            <div>
              <NavLink
                className={({ isActive }) =>
                  isActive ? classes.activeLink + " link" : "link"
                }
                to="/notifications"
              >
                <img
                  src={NotificationsIcon}
                  alt="Chat Icon"
                  height={25}
                  // width={27}
                />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
